import React from "react";
import styles from "./style.module.css";

const HeaderWarning = () => (
  <div className={styles.banner} role="alert">
    <div className={styles.inner}>
      <svg className={styles.icon} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9A5B00" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7.5v5.5M12 16.5v.01" />
      </svg>
      <p className={styles.text}>
        Blitz never asks for payment through WhatsApp, UPI or other medium. If you receive any calls or messages from
        unverified sources, do not reply or share payment details—block and report immediately.
      </p>
    </div>
  </div>
);

export default HeaderWarning;
